import React from 'react'
import abc_2 from "../helper/images/abc_2.png";
import def from "../helper/images/def.png";
import mlj from "../helper/images/logo.png";
import g20 from "../helper/images/g20-logo.png";

function NewHeader() {
  return (
    <>
        <header className='headers'>
		<div class="container">
            <div className='d-flex justify-content-start align-items-center headFlex'>
			<div class="logoOne lgoanu"><img src={abc_2} width="80px"/></div>
			<div class="logoOne logomoe"><img src={def}/></div>
			<div class="logoOne logoaicte"><img src={mlj} width="80px"/></div>
			<div class="logoOne logog20"><img src={g20} width="140px"/></div>
            </div>
		</div>
	</header>
    </>
  )
}

export default NewHeader